import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  useMediaQuery,
  useColorMode,
  DrawerFooter,
  Button,
  Text,
} from "@chakra-ui/react";
import { SCREEN_SIZES } from "ui";
import Image from "next/image";
import lineLight from "../assets/lineLight.svg";
import lineDark from "../assets/lineDark.svg";
import { ModalHeader } from "./ModalHeader";
interface ModalDrawerProps {
  children: any;
  isOpen: boolean;
  onClose: () => void | any;
  onCloseComplete?: () => void;
  headerTitle?: string;
  showMobileCloseButton?: boolean;
  headerPosition?: "center" | "left";
  version?: 1 | 2;
}

export const ModalDrawer = ({
  children,
  isOpen,
  onClose,
  onCloseComplete,
  headerTitle,
  showMobileCloseButton = false,
  headerPosition = "center",
  version = 2,
}: ModalDrawerProps) => {
  const [isMobile] = useMediaQuery(SCREEN_SIZES.MOBILE);
  const { colorMode } = useColorMode();

  if (isMobile) {
    return (
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        onCloseComplete={onCloseComplete}
        placement="bottom"
      >
        <DrawerOverlay
          bg={version === 1 ? "Base_Overlay" : "brand.modalOverlay"}
        />
        <DrawerContent
          backgroundColor={
            version === 1 ? "Base_Card" : "brand.backgroundLight"
          }
        >
          <Box my="24px 40px" textAlign="center">
            <Image
              src={colorMode === "light" ? lineLight : lineDark}
              width={24}
              height={2}
              alt="line"
            />
          </Box>
          {headerTitle && (
            <DrawerHeader textAlign={headerPosition} color="Text_Main">
              {headerTitle}
            </DrawerHeader>
          )}
          <DrawerBody mb={showMobileCloseButton ? "0px" : "16px"}>
            {children}
          </DrawerBody>
          {showMobileCloseButton && (
            <DrawerFooter justifyContent="center">
              <Button
                variant="outline"
                borderColor="Base_Divider"
                onClick={onClose}
              >
                <Text color="Text_Main">Close</Text>
              </Button>
            </DrawerFooter>
          )}
        </DrawerContent>
      </Drawer>
    );
  }
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
    >
      <ModalOverlay
        bg={version === 1 ? "Base_Overlay" : "brand.modalOverlay"}
      />
      <ModalContent
        backgroundColor={version === 1 ? "Base_Card" : "brand.backgroundLight"}
        p="24px"
      >
        <ModalHeader title={headerTitle} onClose={onClose} />
        <ModalBody p="0px">{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
